import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";

import { Button, Icon, Popup } from "semantic-ui-react";

import { useIntl } from "react-intl";

type UserProfileImageProps = {
  readOnly?: boolean;
  src: string;
  onChange: (file: File, fileUrl: string) => void;
  onClear: () => void;
};

const UserProfileImage: React.FC<UserProfileImageProps> = (props) => {
  const intl = useIntl();
  const inputFile = useRef<HTMLInputElement>(null);
  const [imageSrc, setImageSrc] = useState<string>("");

  useEffect(() => {
    if (props.src !== imageSrc && imageSrc) {
      setImageSrc("");
    }
  }, [props.src]);

  const onButtonClick = (): void => {
    inputFile.current?.click();
  };

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0];

    if (!file) {
      return;
    }

    const fileUrl = URL.createObjectURL(file);

    setImageSrc(fileUrl);
    props.onChange(file, fileUrl);
  };

  const handleClearImage = useCallback(() => {
    if (inputFile.current) {
      inputFile.current.value = "";
    }

    setImageSrc("");
    props.onClear();
  }, [props]);

  return (
    <div className="profile-image-section">
      <img className="profile-image" alt="profile" src={props.src} />
      <div className="profile-button">
        <input
          ref={inputFile}
          id="file"
          style={{ display: "none" }}
          accept=".jpg,.jpeg,.png"
          type="file"
          onChange={handleImageChange}
        />
        {!props.readOnly && (
          <Button
            style={{ backgroundColor: "var(--primary-theme-color-half)" }}
            labelPosition="right"
            icon
            onClick={onButtonClick}
          >
            แก้ไขรูปภาพ{" "}
            <Icon style={{ backgroundColor: "var(--primary-theme-color-08)" }} name="picture" />
          </Button>
        )}

        {!!imageSrc && (
          <Popup
            content="Remove image"
            trigger={<Button color="red" icon="close" onClick={handleClearImage} />}
            hideOnScroll
          />
        )}
      </div>

      {!props.readOnly && (
        <>
          <span className="profile-text">กรุณาเลือกไฟล์ .jpg, .jpeg หรือ .png</span>
          <span className="profile-text">
            {intl.formatMessage({ id: "ขนาดไม่เกิน 2 Mb เท่านั้น" })}
          </span>
        </>
      )}
    </div>
  );
};

export default UserProfileImage;
